import sample_1 from './sample_1.png';

export const dynamicElementsPlusSImpressions = {
    sample_1,
};
